// Shared provide()/inject() keys, so a rename is caught by every consumer at once
// instead of relying on repeated string literals staying in sync.
export const injectionKeysConstante = Object.freeze({
  FOCUS_SCROLL_DISABLED: "isFocusScrollDisabled",
  LANDING_HERO_OVERRIDE: "setLandingHeroOverride",
});
